<template>
  <div v-if="trend" class="trend-container">
    <div :class="['trend-badge', `trend-${trend.trend}`]">
      <span class="direction">{{ trend.direction }}</span>
      <span class="value">{{ trend.value }}</span>
      <span class="label">{{ trendLabel }} (7 días)</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrendIndicator',
  props: {
    trend: {
      type: Object,
      default: null
      // { trend: 'improving'|'declining'|'stable', value: '0.3', direction: '↘️' }
    }
  },
  computed: {
    trendLabel () {
      if (!this.trend) return ''
      const labels = {
        improving: 'Mejorando',
        declining: 'Empeorando',
        stable: 'Estable'
      }
      return labels[this.trend.trend] || ''
    }
  }
}
</script>

<style scoped lang="scss">
.trend-container {
  margin-top: 16px;
}

.trend-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;

  &.trend-improving {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #81c784;
  }

  &.trend-declining {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #ef5350;
  }

  &.trend-stable {
    background-color: #fff8e1;
    color: #f57f17;
    border: 1px solid #fbc02d;
  }
}

.direction {
  font-size: 20px;
  line-height: 1;
}

.value {
  font-size: 16px;
  font-weight: bold;
}

.label {
  font-size: 12px;
  opacity: 0.8;
}
</style>
